import { createContext } from 'react';
import uuid from 'react-uuid';
import { decorate, observable, action, toJS } from 'mobx';

import api from '../api';
import * as fn from '../utilities/_functions';

export class InternalFormInputCreate {
    id = null;
    data = {
        internalFormTemplateId: null,
        key: null,
        name: null,
        descriptionHtml: null,
        label: null,
        type: null,
        isRequired: false,
        metadata: null,
    };
    isReady = false;
    isSaving = false;
    hasUnsavedChanges = false;

    cancelInternalFormInputCreate = null;

    initialize = (internalFormTemplateId) => {
        this.clear();
        this.id = uuid();
        this.data.internalFormTemplateId = internalFormTemplateId;
        this.isReady = true;
    }

    setMetadata = (key, value) => {
        let metadata = this.data.metadata;

        if (!metadata) {
            metadata = {};
        }

        if (!metadata.hasOwnProperty(key)) {
            metadata = { ...metadata, ...{ [key]: value } };
        } else {
            metadata[key] = value;
        }

        this.data.metadata = metadata;
    }

    removeMetadata = (key) => {
        let metadata = this.data.metadata;

        if (metadata && metadata.hasOwnProperty(key)) {
            delete metadata[key];
        }
    }

    getMetadata = (key) => {
        if (!this.data.metadata) return undefined;
        return this.data.metadata[key];
    }

    save = (notify) => {
        const that = this;

        if (!!notify) {
            this.isSaving = true;
        }

        return new Promise((resolve, reject) => {
            let option = toJS(that.data);

            if (that.hasUnsavedChanges) {
                api.InternalFormInputs.create(option, (c) => { that.cancelInternalFormInputCreate = c })
                    .then(({ data }) => {
                        that.id = data.id;
                        that.hasUnsavedChanges = false;
                        option.id = data.id;
                        resolve(option);
                    })
                    .catch(() => {
                        reject();
                    })
                    .finally(() => {
                        that.isSaving = false;
                    })
            } else {
                that.hasUnsavedChanges = false;
                that.isSaving = false;
            }
        })
    }

    clear = () => {
        this.id = null;
        this.data.internalFormTemplateId = null;
        this.data.key = null;
        this.data.name = null;
        this.data.descriptionHtml = null;
        this.data.label = null;
        this.data.type = null;
        this.data.isRequired = false;
        this.data.metadata = null;
        this.isReady = false;
        this.isSaving = false;
        this.hasUnsavedChanges = false;

        if (fn.isFunction(this.cancelInternalFormInputCreate)) {
            this.cancelInternalFormInputCreate();
            this.cancelInternalFormInputCreate= null;
        }
    }
}

decorate(InternalFormInputCreate, {
    id: observable,
    data: observable.deep,
    isReady: observable,
    isSaving: observable,
    initialize: action,
    setMetadata: action,
    removeMetadata: action,
    getMetadata: action,
    hasUnsavedChanges: observable,
    save: action,
    clear: action,
})

export default createContext(new InternalFormInputCreate());